import SvgIconLoading from '@/icons/SvgIconLoading';
import SvgNotFound from '@/icons/SvgNotFound';

import SvgAddUser from '@/icons/add-user.svg';
import SvgAddUserFill from '@/icons/add-user-fill.svg';
import SvgRemoveUser from '@/icons/remove-user.svg';
import SvgCall from '@/icons/call.svg';
import SvgCamera from '@/icons/camera.svg';
import SvgChat from '@/icons/chat.svg';
import SvgChats from '@/icons/chats.svg';
import SvgClock from '@/icons/clock.svg';
import SvgClockActive from '@/icons/clock-a.svg';
import SvgClose from '@/icons/close.svg';
import SvgCloseLg from '@/icons/close-lg.svg';
import SvgCloseStroke from '@/icons/close-circle.svg';
import SvgFavorite from '@/icons/favorite.svg';
import SvgFavorited from '@/icons/favorited.svg';
import SvgGlobe from '@/icons/globe.svg';
import SvgLoading from '@/icons/loading.svg';
import SvgLoadingB from '@/icons/loading-b.svg';
import SvgLock from '@/icons/lock.svg';
import SvgArrowDown from '@/icons/arrow-down.svg';
import SvgMic from '@/icons/mic.svg';
import SvgMicMute from '@/icons/mic-mute.svg';
import SvgSignal from '@/icons/signal.svg';
import SvgSearch from '@/icons/search.svg';
import SvgUser from '@/icons/user.svg';
import SvgUserO from '@/icons/user-o.svg';
import SvgContact from '@/icons/contact.svg';
import SvgContactActive from '@/icons/contact-a.svg';
import SvgUpNav from '@/icons/arrow-up-nav.svg';
import SvgDownNav from '@/icons/arrow-down-nav.svg';
import SvgMissed from '@/icons/missed.svg';
import SvgE from '@/icons/em-icon-e.svg';
import SvgLocation from '@/icons/location.svg';
import SvgEmail from '@/icons/email.svg';
import SvgUnlock from '@/icons/unlock.svg';
import SvgTick from '@/icons/tick.svg';
import SvgMenu from '@/icons/menu.svg';
import SvgPip from '@/icons/preview.svg';
import SvgNetwork from '@/icons/network.svg';
import SvgDesktop from '@/icons/desktop.svg';
import SvgDesktopLock from '@/icons/desktop-lock.svg';
import SvgVideo from '@/icons/video.svg';
import SvgEdit from '@/icons/edit.svg';
import SvgEditList from '@/icons/edit-list.svg';
import SvgVideoStopped from '@/icons/video-stopped.svg';
import SvgLinkDevice from '@/icons/link-device.svg';
import SvgShare from '@/icons/share.svg';
import SvgTransfer from '@/icons/transfer.svg';
import SvgScan from '@/icons/scan.svg';
import SvgSpeakerOn from '@/icons/speaker.svg';
import SvgSpeakerOff from '@/icons/speaker-mute.svg';
import SvgPlusFill from '@/icons/plus-circle-fill.svg';
import SvgMinusFill from '@/icons/minus-circle-fill.svg';
import SvgArrowBold from '@/icons/arrow-bold.svg';
import SvgUsers from '@/icons/users.svg';
import SvgPlus from '@/icons/plus.svg';
import SvgMinus from '@/icons/minus.svg';
import SvgArrowBoth from '@/icons/arrow-both.svg';
import SvgArrowAll from '@/icons/arrow-all.svg';
import SvgAlert from '@/icons/alert.svg';
import SvgArrowCircle from '@/icons/arrow-circle.svg';
import SvgSettings from '@/icons/settings.svg';
import SvgCameraFill from '@/icons/camera-fill.svg';
import SvgNumPad from '@/icons/numPad.svg';
import SvgChatO from '@/icons/chat-o.svg';
import SvgChatNew from '@/icons/chat-new.svg';
import SvgCameraAdd from '@/icons/camera-add-o.svg';
import SvgTickl from '@/icons/tick-l.svg';
import SvgTickld from '@/icons/tick-ld.svg';
import SvgAddGroup from '@/icons/add-group.svg';
import SvgGroup from '@/icons/group.svg';
import SvgTitle from '@/icons/title.svg';
import SvgImgUpload from '@/icons/img-upload.svg';
import SvgCallCircle from '@/icons/call-circle.svg';
import SvgHelp from '@/icons/help.svg';
import SvgPhoto from '@/icons/photo.svg';
import SvgOrg from '@/icons/org.svg';
import SvgTrash from '@/icons/trash.svg';
import SvgTrashO from '@/icons/trash-o.svg';
import SvgExit from '@/icons/exit.svg';
import SvgAddUsersFill from '@/icons/add-users-fill.svg';
import SvgArrowRight from '@/icons/arrow-right.svg';
import Svgplay from '@/icons/play.svg';
import SvgPause from '@/icons/pause.svg';

export default {
  name: 'SvgIcon',
  components: {
    SvgIconLoading,
    SvgAddUser,
    SvgAddUserFill,
    SvgRemoveUser,
    SvgCall,
    SvgCamera,
    SvgChat,
    SvgChats,
    SvgClock,
    SvgClockActive,
    SvgFavorite,
    SvgFavorited,
    SvgClose,
    SvgCloseLg,
    SvgCloseStroke,
    SvgGlobe,
    SvgLoading,
    SvgLoadingB,
    SvgLock,
    SvgArrowDown,
    SvgMic,
    SvgMicMute,
    SvgSearch,
    SvgSignal,
    SvgUser,
    SvgUserO,
    SvgContact,
    SvgContactActive,
    SvgUpNav,
    SvgDownNav,
    SvgMissed,
    SvgE,
    SvgLocation,
    SvgEmail,
    SvgUnlock,
    SvgTick,
    SvgMenu,
    SvgPip,
    SvgNetwork,
    SvgDesktop,
    SvgDesktopLock,
    SvgVideo,
    SvgEdit,
    SvgEditList,
    SvgVideoStopped,
    SvgLinkDevice,
    SvgShare,
    SvgTransfer,
    SvgScan,
    SvgSpeakerOn,
    SvgSpeakerOff,
    SvgPlusFill,
    SvgMinusFill,
    SvgArrowBold,
    SvgUsers,
    SvgPlus,
    SvgMinus,
    SvgArrowBoth,
    SvgArrowAll,
    SvgAlert,
    SvgArrowCircle,
    SvgSettings,
    SvgCameraFill,
    SvgNumPad,
    SvgChatO,
    SvgChatNew,
    SvgCameraAdd,
    SvgTickl,
    SvgTickld,
    SvgAddGroup,
    SvgGroup,
    SvgTitle,
    SvgImgUpload,
    SvgCallCircle,
    SvgHelp,
    SvgPhoto,
    SvgOrg,
    SvgTrash,
    SvgTrashO,
    SvgExit,
    SvgAddUsersFill,
    SvgArrowRight,
    Svgplay,
    SvgPause
  },
  props: {
    icon: {
      type: String,
      default: SvgNotFound
    }
  }
};
